
// src/lib/useAlarm.js
import { useEffect, useRef } from "react";

/** Play a short beep using Web Audio API */
export function useBeep() {
    const ctxRef = useRef(null);

    useEffect(() => {
        if (typeof window !== "undefined" && "AudioContext" in window) {
            ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
        }
    }, []);

    const beep = (freq = 880, durationMs = 180) => {
        const ctx = ctxRef.current;
        if (!ctx) return;
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "sine";
        o.frequency.value = freq;
        o.connect(g);
        g.connect(ctx.destination);
        o.start();
        g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + durationMs / 1000);
        setTimeout(() => o.stop(), durationMs);
    };

    return beep;
}

/** Request notification permission and show a notification */
export async function showNotification(title, body) {
    try {
        if (!("Notification" in window)) return;
        if (Notification.permission === "default") {
            await Notification.requestPermission();
        }
        if (Notification.permission === "granted") {
            new Notification(title, { body });
        }
    } catch { }
}
